<template>
  <svg
    version="1.1"
    :width="width"
    :height="height"
    viewBox="0 0 14 26"
    :style="{
      transform: `rotate(${rotate})`
    }"
    @click="$emit('click')"
  >
    <path fill="currentColor" d="M0,0L14,13L0,26V17Z" />
  </svg>
</template>

<script>
const DIRECTION = {
  RIGHT: "right",
  LEFT: "left",
  TOP: "top",
  BOTTOM: "bottom"
};

// @group Icons
// Scroll arrow icon
export default {
  name: "ScrollArrow",
  props: {
    /** width in pixels */
    width: {
      type: Number,
      default: 24
    },
    /** height in pixels */
    height: {
      type: Number,
      default: 24
    },
    /** foreground color */
    color: {
      type: String,
      default: "white"
    },
    /** arrow direction (right/left/top/bottom) */
    direction: {
      type: String,
      default: "right",
      validator(val) {
        return Object.values(DIRECTION).includes(val);
      }
    }
  },
  computed: {
    rotate() {
      switch (this.direction) {
        case DIRECTION.RIGHT:
          return "0";
        case DIRECTION.BOTTOM:
          return "90deg";
        case DIRECTION.LEFT:
          return "180deg";
        case DIRECTION.TOP:
          return "270deg";
        default:
          return "0";
      }
    }
  }
};
</script>
